export default "__VITE_ASSET__d8c3e9b0__"